import React from 'react'
import classes from './NumberBlock.module.css'

const NumberBlock = ({ digit }) => {
    return <div className={classes.container}>{Number.isNaN(digit) ? '-' : digit}</div>
}

export default NumberBlock
